import React from 'react';
import PropTypes from 'prop-types';

import style from './Input.module.css';

const Input = React.memo(
  ({
    name,
    placeholder = '',
    value = '',
    autocomplete = 'on',
    id,
    styles = '',
    type,
    'data-testid': testId,
    onChange,
  }) => {
    return (
      <input
        value={value}
        type={type || 'input'}
        name={name}
        id={id}
        autoComplete={autocomplete}
        placeholder={placeholder}
        className={`form-control ${style.formControl} ${styles}`}
        data-testid={testId}
        onChange={onChange}
      />
    );
  },
);

Input.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  autocomplete: PropTypes.string,
  id: PropTypes.string.isRequired,
  styles: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default Input;
